enum ResolveSpacingByAction {
  'CLOSE_ALL_SPACES' = 'CLOSE_ALL_SPACES',
  'EQUAL_AROUND_UPPER' = 'EQUAL_AROUND_UPPER',
  'DISTAL_TO_UPPER_LATERALS' = 'DISTAL_TO_UPPER_LATERALS',
  'DISTAL_TO_UPPER_CANINES' = 'DISTAL_TO_UPPER_CANINES',
}

export { ResolveSpacingByAction }
